import React from 'react';
import PropTypes from 'prop-types';
import {Panel} from 'react-bootstrap';
import Moment from 'moment';
import {Link} from 'react-router';

class RecentlyViewedMaps extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			recent_maps_open : true
		}

		this.renderRecentlyViewedMaps = this.renderRecentlyViewedMaps.bind(this);
	}

	renderRecentlyViewedMaps(map, index, array) {
		if(!map) {
			return <div key={index}></div>
		}
		if(typeof map === 'object' && map.properties) {
			var class_name;

			if(index === array.length - 1)
				class_name = 'individual-map-last'
			else
				class_name = 'individual-map'

			// Initialize stars
			let stars = [];
			for(let i = 0; i < map.properties.star_level; i++) {
				stars.push(<div className='fa fa-star' />)
			}
			return (
				<div key={index}>
					<div className={class_name + ' col-md-12'}>
						<Link to={'/map/search/' + map._id}>
							<div className='row'>
								<div className='col-md-6'>
									<h5 >{map.properties.cities[0] || '(No Cities Listed)'}</h5>
									<h5 >{map.properties.states[0] || '(No States Listed)'}</h5>
								</div>
								<div className='col-md-6'>
									<h5>
										{Moment(map.properties.storm_date).format('MMMM Do YYYY') ||
										'(No Storm Date Listed)'}
									</h5>
								</div>
							</div>
							<div className='row'>
								<div className='col-md-12'>
									{stars.map(s => s)}
								</div>
							</div>
						</Link>
					</div>
				</div>
			)
		}
	}

	render() {
		return (
			<div className='recently-viewed-maps-container panel'>
				{(() => {
					if(this.props.recently_viewed_maps && this.props.recently_viewed_maps.length > 0) {
						return (
							<div>
								<div className='panel-heading'>
				      		<div className='col-md-11 col-xs-11'>
				          	<h2 className='panel-title recent-clients-panel'>
				          		Recently Viewed Maps
				          	</h2>
				        	</div>
				        	<div
				        		className={
				        			'pull-right recent-maps-caret ' +
				        			(this.state.recent_maps_open ?
				        			'fa fa-caret-up' :
				        			'fa fa-caret-down')
				        		}
				        		onClick={() => {this.setState({
				        			recent_maps_open : !this.state.recent_maps_open
				        		})}}
				        	/>
				        </div>
				      	<Panel collapsible expanded={this.state.recent_maps_open}>
				    			{this.props.recently_viewed_maps.map(this.renderRecentlyViewedMaps)}
				    		</Panel>
							</div>
						)
					}
					else {
						return (
							<div className='row'>
      					<div className='col-md-12 col-xs-12'>
          				<div
          					id='select-role-alert'
          					className='alert alert-info'>
	          				<h4>No maps have been viewed.<strong><Link to='/map/search/'> Click Here </Link></strong>to check out some maps</h4>
	          			</div>
	          		</div>
          		</div>
							)
					}
				})()}
      </div>
		)
	}
}

export default RecentlyViewedMaps;



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/recentlyViewedMaps.js